export default __webpack_public_path__ + "static/media/circle-text.95a2f35f.svg";